import { FC } from 'react';

import { IconProps } from './types';

export const NoPhotoIcon: FC<IconProps> = ({ size, height = 31, width = 31 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 31 31"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill="#F3F6FA"
			fillRule="evenodd"
			d="M2 0h26a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Z"
		/>
		<path fill="#fff" d="M2 2h26v26H2V2Z" />
		<path
			fill="#F3F6FA"
			fillRule="evenodd"
			d="M4.293 4.293a1 1 0 0 1 1.414 0l1.583 1.59.01.01 3.95 3.95.038.03.036.04 2.757 2.76.038.03c.012.02.025.03.036.04l11.552 11.55c.391.39.391 1.03 0 1.42-.195.19-.45.29-.707.29-.256 0-.512-.1-.707-.29l-.998-1a2.99 2.99 0 0 1-1.295.29H8c-1.654 0-3-1.35-3-3v-14c.001-.45.104-.89.296-1.29l-1.003-1a1.006 1.006 0 0 1 0-1.42ZM7 8.413v13.59c0 .55.45 1 1 1h.586l6.5-6.5-1.797-1.8c-.408.2-.85.29-1.294.29-.769 0-1.537-.29-2.122-.87a2.99 2.99 0 0 1-.879-2.13c0-.45.101-.89.292-1.29L7 8.413Zm9.5 9.5-5.086 5.09h10.172l-5.086-5.09ZM22 5.003c1.654 0 3 1.35 3 3v9.98a1.002 1.002 0 0 1-.978 1.02h-.044c-.279-.01-.53-.13-.708-.32l-2.977-2.97a1.006 1.006 0 0 1 0-1.42 1 1 0 0 1 1.414 0l1.293 1.3v-7.59c0-.55-.448-1-1-1H12c-.552 0-1-.45-1-1s.448-1 1-1h10Z"
		/>
	</svg>
);
